var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.size,on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"button__text",attrs:{"lastKey":_vm.text}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }